import React from "react";
import { Card, CardBody, Collapse, Badge } from "reactstrap";

const EvaluationActivityCard = ({ activity, index, isOpen, toggleAccordion }) => {
    const totalXp = activity.objectives?.reduce((accObj, obj) => {
        const topicsXp = obj.topics?.reduce((accTopic, topic) => accTopic + (Number(topic.xp) || 0), 0) || 0;
        return accObj + topicsXp;
    }, 0) || 0;

    const themeColor = activity.color || '#3b82f6';

    return (
        <Card className="border-0 rounded-4 overflow-hidden mb-0" style={{ backgroundColor: "transparent", backdropFilter: "blur(10px)", WebkitBackdropFilter: "blur(10px)", boxShadow: isOpen ? "0 4px 15px rgba(0,0,0,0.08)" : "0 2px 8px rgba(0,0,0,0.04)", transition: "all 0.3s ease" }}>
            <div 
                className="d-flex align-items-center p-4 px-4 cursor-pointer bg-transparent position-relative"
                onClick={() => toggleAccordion(activity.id)}
            >
                <div 
                    className="rounded-circle d-flex align-items-center justify-content-center me-3 overflow-hidden shadow-sm" 
                    style={{ 
                        width: "100px", height: "100px", 
                        border: `3px solid ${themeColor}`, 
                        flexShrink: 0,
                        backgroundColor: `${themeColor}10` 
                    }}
                >
                    {activity.photoUrl ? (
                        <img src={activity.photoUrl} alt={activity.name} className="w-100 h-100 object-fit-cover" />
                    ) : (
                        <span className="fw-bold font-size-36" style={{ color: '#343a40' }}>
                            {index + 1}
                        </span>
                    )}
                </div>
                
                <div className="flex-grow-1 ms-3">
                    <h6 className="mb-0 fw-bold text-dark" style={{ letterSpacing: "-0.5px", fontSize: "36px" }}>{activity.name}</h6>
                    <div className="d-flex align-items-center gap-3 mt-3">
                        <Badge color="soft" style={{ backgroundColor: `${themeColor}20`, color: '#343a40', fontSize: '20px', padding: '10px 18px', borderRadius: '12px' }}>
                            Nível {index + 1}
                        </Badge>
                        {totalXp > 0 && (
                            <span className="text-dark fw-medium d-flex align-items-center opacity-75" style={{ fontSize: '22px' }}>
                                <i className="mdi mdi-star text-warning me-2 font-size-24"></i> {totalXp} XP 
                            </span>
                        )}
                    </div>
                </div>

                <div className="ps-2 d-flex align-items-center">
                    <div className="rounded-circle d-flex align-items-center justify-content-center" style={{ width: '65px', height: '65px', backgroundColor: isOpen ? `${themeColor}15` : 'rgba(0,0,0,0.05)', transition: 'all 0.3s' }}>
                        <i className={`mdi ${isOpen ? 'mdi-chevron-up' : 'mdi-chevron-down'}`} style={{ fontSize: "42px", fontWeight: "300", color: isOpen ? themeColor : '#adb5bd' }}></i>
                    </div>
                </div>
            </div>

            <Collapse isOpen={isOpen}>
                <CardBody className="pt-4 pb-5 px-4 px-md-5 bg-transparent border-top" style={{ borderColor: 'rgba(0,0,0,0.05)' }}>
                    
                    {activity.description && (
                        <div className="mb-4 mt-2 p-4 rounded-3" style={{ backgroundColor: `${themeColor}05`, borderLeft: `5px solid ${themeColor}` }}>
                            <p className="text-dark mb-0 fw-medium" style={{ lineHeight: "1.6", fontSize: "24px" }}>
                                <i className="mdi mdi-information-outline me-3 font-size-32" style={{ color: themeColor }}></i>
                                {activity.description}
                            </p>
                        </div>
                    )}

                    {(!activity.objectives || activity.objectives.length === 0) ? (
                        <div className="text-center py-4 rounded-3 mt-2" style={{ backgroundColor: 'transparent' }}>
                            <p className="text-muted mb-0">Esta atividade ainda não possui objetivos cadastrados.</p>
                        </div>
                    ) : (
                        <div className="mt-2 text-start">
                            {[...activity.objectives].sort((a, b) => a.order - b.order).map((objective, objIndex) => (
                                <div key={objective.id} className="mb-5 position-relative">
                                    
                                    <div className="d-flex align-items-center mb-4 pb-3 border-bottom">
                                        <div className="rounded d-flex align-items-center justify-content-center me-4 font-size-24" style={{ width: '60px', height: '60px', backgroundColor: `${themeColor}20`, color: '#343a40', fontWeight: 'bold' }}>
                                            {objIndex + 1}
                                        </div>
                                        <h2 className="mb-0 fw-bold text-dark flex-grow-1" style={{ fontSize: "32px" }}>{objective.name}</h2>
                                    </div>
                                    
                                    <div className="d-flex flex-column gap-4 ps-3 ms-4 border-start" style={{ borderColor: 'rgba(0,0,0,0.05)' }}>
                                        {([...objective.topics] || []).sort((a,b) => a.order - b.order).map((topic, topicIndex) => (
                                            <div key={topic.id} className="d-flex flex-column flex-sm-row justify-content-between align-items-start align-items-sm-center p-4 ms-4 rounded-3" style={{ backgroundColor: 'transparent', border: '1px solid rgba(0,0,0,0.05)' }}>
                                                <div className="pe-4 mb-2 mb-sm-0">
                                                    <span className="text-dark font-size-22 fw-bold me-3 opacity-75">{objIndex + 1}.{topicIndex + 1}</span>
                                                    <span className="text-dark font-size-24 fw-bold">{topic.name}</span>
                                                    
                                                    {topic.isFundamental && (
                                                        <Badge className="ms-3 font-size-16 px-3 py-2 shadow-sm" style={{ backgroundColor: '#edc453', color: '#ffffff', border: '1px solid #e2b73f' }}>
                                                            Fundamental
                                                        </Badge>
                                                    )}
                                                </div>
                                                <div className="flex-shrink-0 text-sm-end ms-sm-auto">
                                                    <span className="badge rounded-pill fw-bold px-4 py-3" style={{ backgroundColor: `${themeColor}20`, color: '#343a40', fontSize: '20px' }}>
                                                        +{topic.xp || 0} pts
                                                    </span>
                                                </div>
                                            </div>
                                        ))}
                                        {(!objective.topics || objective.topics.length === 0) && (
                                            <span className="text-muted small fst-italic ms-4 py-2">Nenhum tópico cadastrado</span>
                                        )}
                                    </div>

                                </div>
                            ))}
                        </div>
                    )}
                </CardBody>
            </Collapse>
        </Card>
    );
};

export default EvaluationActivityCard;
